/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Sc_HelpInputs */

const en_tut_sc_help = /** @type {(inputs: Tut_Sc_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the in-app shortcut list`)
};

const id_tut_sc_help = /** @type {(inputs: Tut_Sc_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka daftar pintasan di dalam aplikasi`)
};

/**
* | output |
* | --- |
* | "Open the in-app shortcut list" |
*
* @param {Tut_Sc_HelpInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_sc_help = /** @type {((inputs?: Tut_Sc_HelpInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Sc_HelpInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_sc_help(inputs)
	return en_tut_sc_help(inputs)
});